<script setup>
</script>

<template>
  <p class="cloud-calculator__subtitle">
    {{ $Bitrix.Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_SUBTITLE') }}
  </p>
</template>
